export class StringUtility {
    public static removeTags(text: string | undefined): string | undefined {
        if (!text)
            return undefined;

        let regexA = new RegExp('(<a(.*?)>(.*?)<\/a>)', 'ig');
        let result = text.replace(regexA, '');
        //#297.2
        let regex = new RegExp('(<([^>]+)>)', 'ig');
        result = result.replace(regex, '');
        //#312
        let regexNBSP = new RegExp('(&nbsp;)', 'ig');
        result = result.replace(regexNBSP, '');

        return result;
    }

}


// WEBPACK FOOTER //
// ./ClientApp/services/utilities/stringUtility.ts